import React, { useState, useEffect } from 'react';
import '../../styles/RequestHistory.css';
import { getRequestHistory } from '../../services/api';

function RequestHistory() {
  const [search, setSearch] = useState('');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const data = await getRequestHistory();
        setHistory(data);
      } catch (err) {
        console.error('Failed to fetch request history:', err);
      }
    };
    fetchHistory();
  }, []);

  const filteredHistory = history.filter(h => 
    h.service.toLowerCase().includes(search.toLowerCase()) ||
    h.status.toLowerCase().includes(search.toLowerCase())
  );

  const handleExport = () => {
    const csv = filteredHistory.map(h => `${h.service},${h.date},${h.status}`).join('\n');
    const blob = new Blob([`Service,Date,Status\n${csv}`], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'request_history.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="sp-request-history">
      <h2 className="sp-history-title">Request History</h2>
      <div className="sp-history-controls">
        <input
          className="sp-history-search"
          type="text"
          placeholder="Search history..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="sp-export-btn" onClick={handleExport}>Export</button>
      </div>
      <table className="sp-history-table">
        <thead>
          <tr>
            <th>Service</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredHistory.map((request) => (
            <tr key={request.id} className="sp-history-row">
              <td>{request.service}</td>
              <td>{request.date}</td>
              <td>{request.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RequestHistory;